  class AccordionContainer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const button = this.querySelector('.accordion');
      const panel = this.querySelector('.panel');

      if (button && panel) {
        button.addEventListener('click', () => {
          button.classList.toggle('active');

          const isOpen = panel.style.display === 'block';

          panel.style.display = isOpen ? 'none' : 'block';

          // Handle write-review-button logic
          const writeReviewBtn = document.querySelector('.write-review-button');
          const writeReviewForm = document.querySelector('.write-review-form-container');

          if (!isOpen) {
            if (writeReviewBtn) writeReviewBtn.style.display = 'block';
          } else {
            if (writeReviewForm) writeReviewForm.style.display = 'none';
          }
        });
      }
    }
  }

  customElements.define('accordion-container', AccordionContainer);
